"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var CheckOutline = function CheckOutline(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#000' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="1em" height="1em"' : 'width="100%"';
  var title = 'Check Outline Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" ").concat(iconSize, " viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <title>").concat(title, "</title>\n      <path d=\"M11.8041 0.440918C5.2898 0.440918 0 5.68173 0 12.196C0 18.7103 5.2898 23.9511 11.8041 23.9511C18.3184 23.9511 23.6082 18.6613 23.6082 12.196C23.6082 5.73071 18.2694 0.440918 11.8041 0.440918ZM11.8041 22.4817C6.12245 22.4817 1.46939 17.8777 1.46939 12.147C1.46939 6.46541 6.12245 1.81235 11.8041 1.81235C17.4857 1.81235 22.1388 6.41643 22.1388 12.147C22.1388 17.8777 17.4857 22.4817 11.8041 22.4817Z\"\n        fill=\"").concat(color, "\"\n      />\n      <path d=\"M9.06145 16.8982L4.50635 12.3921L6.31859 10.5798L9.94308 14.2043L17.1921 6.95532L19.0043 8.76757L9.94308 17.7798L9.06145 16.8982Z\"\n        fill=\"").concat(color, "\"\n      />\n    </svg>\n  ");
};

var _default = CheckOutline;
exports["default"] = _default;